
<div class="amplify-greeting" *ngIf="signedIn">
    <div class="amplify-greeting-text">{{ greeting }}</div>
    <div class="amplify-greeting-flex-spacer"></div>
    <ion-button
        class="amplify-greeting-sign-out"
        size="small"
        *ngIf="signedIn"
        (click)="onSignOut()"
        data-test="sign-out-button"
      >{{ this.amplifyService.i18n().get('Sign Out') }}</ion-button>
</div>
